import { Link } from 'react-router-dom';
import styled from 'styled-components';

import Button from 'src/app/components/Elements/Button';
import { Typography } from 'src/app/components/Elements/Typography';
import type { ThemeSpaceType, ThemeType } from 'src/styles/theme';

export const PromoPageLink = styled(Link)`
  color: ${props => props.theme.colors.capsuleGreen50} !important;
  display: inline-block;
`;

export const PromoImageWrapper = styled.div`
  flex: 1 0;
  display: flex;
  flex-direction: column;
`;

export const OtcPromoImage = styled.img`
  max-width: ${props => props.theme.space['40']};
  min-width: ${props => props.theme.space['15.0']};
  width: 80%;
  margin: auto;
  display: block;
  ${props => props.theme.mediaQueries.mediumDown} {
    display: inline-block;
  }
`;

export const IconListContainer = styled.div`
  flex: 1 0 25%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${props => props.theme.mediaQueries.smallDown} {
    padding-top: ${props => props.theme.space['1.0']};
  }
`;

interface RedeemOfferButtonProps {
  marginTop: ThemeSpaceType;
  theme: ThemeType;
}

export const RedeemOfferButton = styled(Button)`
  &&& {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 4.8rem;
    max-width: 32.5rem;
    padding: 0 ${props => props.theme.space.s5}!important;
    margin-top: ${(props: RedeemOfferButtonProps) => props.theme.space[props.marginTop]};
    margin-bottom: ${props => props.theme.space.s5};
    ${props => props.theme.mediaQueries.mediumDown} {
      max-width: none;
    }
  }
`;

// Layout Styles

export const CTAContent = styled.div`
  flex: 1;
  ${props => props.theme.mediaQueries.mediumDown} {
    width: 100%;
  }
`;

export const CaptionSection = styled.div`
  color: white;
  margin-top: ${props => props.theme.space['7.0']};
  margin-bottom: ${props => props.theme.space['10.0']};
  ${props => props.theme.mediaQueries.smallDown} {
    margin-top: ${props => props.theme.space['6.0']};
    margin-bottom: ${props => props.theme.space['8.0']};
  }

  font-family: ${props => props.theme.fonts.circular};
  font-weight: ${props => props.theme.fontWeights.bold};
  padding: ${props => props.theme.space.none} !important;
  font-size: ${props => props.theme.fontSizes.headerTwo};
  line-height: ${props => props.theme.lineHeights.headerTwo};

  ${props => props.theme.mediaQueries.mediumDown} {
    font-size: ${props => props.theme.fontSizes.headerTwo};
    line-height: ${props => props.theme.lineHeights.headerTwo};
  }
`;

export const SubheaderContent = styled.div`
  max-width: 60rem;
`;

export const Subheader = styled(Typography)`
  font-weight: ${props => props.theme.fontWeights.book} !important;
`;

// Form Styles

export const FormContainer = styled.div`
  display: flex;
  flex-direction: row;
  ${props => props.theme.mediaQueries.mediumDown} {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

export const InnerInputsSection = styled.div`
  .row {
    max-width: 85rem;
  }
  ${props => props.theme.mediaQueries.medium} {
    width: 100%;
    flex-direction: column;
    align-self: flex-end;
  }
`;

export const FirstField = styled.div`
  ${props => props.theme.mediaQueries.smallDown} {
    margin-top: ${props => props.theme.space['3.6']};
  }
`;

export const PhoneInputPadding = styled.div`
  padding-bottom: ${props => props.theme.space['2.0']};
  padding-top: ${props => props.theme.space.s2};

  ${props => props.theme.mediaQueries.large} {
    padding-top: ${props => props.theme.space.s2};
    padding-bottom: ${props => props.theme.space.none};
  }
`;

// Get started CTA styles

export const GetStartedContainer = styled(FormContainer)`
  ${props => props.theme.mediaQueries.mediumDown} {
    flex-direction: column-reverse;
  }
`;

export const GetStartedCTAWrapper = styled.div`
  text-align: center;
  max-width: 45rem;
  margin-top: ${props => props.theme.space.s4};
  ${props => props.theme.mediaQueries.mediumDown} {
    max-width: none;
    margin: ${props => props.theme.space.s5} auto ${props => props.theme.space.s8};
  }
`;

export const GetStartedButton = styled(RedeemOfferButton)`
  &&& {
    height: ${props => props.theme.space.s8};
    max-width: none;
  }
`;
